import { businessKey } from 'queryKeys';

import { CONCEPTS } from 'scenes/Gallery/GalleryPage/Concepts/data/queryKeyFactory';

const COMMENTS = 'conceptsComments';

export const commentsQuery = businessKey.query(COMMENTS);
export const list = commentsQuery.grid();
export const mutations = commentsQuery.query(CONCEPTS).mutations();
export const remove = mutations.delete();
export const create = mutations.create();
export const update = mutations.update();
